import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Footprints, ArrowLeft, MailCheck } from "lucide-react";

export default function LupaPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] grain flex flex-col">
      <div className="max-w-6xl w-full mx-auto px-4 h-16 flex items-center">
        <Link to="/masuk" className="flex items-center gap-2 text-[#5C5F5C] hover:text-[#1A1C1A] transition-colors text-sm">
          <ArrowLeft className="h-4 w-4" /> Kembali ke Masuk
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-2 mb-6 justify-center">
            <img src="/talenta-logo.png" alt="TalentaPath" className="h-11 w-11 rounded-full object-contain" />
            <span className="flex flex-col leading-none">
              <span className="font-heading font-black text-xl text-[#1A1C1A]">TalentaPath</span>
              <span className="text-xs font-medium text-[#E25E3E]">powered by Talenta</span>
            </span>
          </div>
          <div className="clay-card p-7" data-testid="lupa-password-card">
            {sent ? (
              <div className="text-center" data-testid="lupa-sent">
                <span className="h-14 w-14 rounded-2xl bg-[#4A6B53]/12 text-[#4A6B53] grid place-items-center mx-auto mb-4"><MailCheck className="h-7 w-7" /></span>
                <h1 className="font-heading font-black text-2xl mb-2 text-[#1A1C1A]">Cek email kamu</h1>
                <p className="text-sm text-[#5C5F5C]">Jika email <b>{email}</b> terdaftar, kami sudah mengirim tautan untuk mengatur ulang kata sandi. Tautan berlaku 1 jam.</p>
                <p className="text-xs text-[#9C9A94] mt-3">Tidak menerima email? Cek folder spam, atau coba lagi beberapa saat.</p>
                <Link to="/masuk" className="inline-block mt-5 px-6 py-3 rounded-full bg-[#1A1C1A] text-white text-sm font-medium">Kembali ke Masuk</Link>
              </div>
            ) : (
              <>
                <h1 className="font-heading font-black text-2xl mb-1 text-[#1A1C1A]">Lupa kata sandi?</h1>
                <p className="text-sm text-[#5C5F5C] mb-6">Masukkan email akunmu. Kami akan kirim tautan untuk mengatur ulang kata sandi.</p>
                <form onSubmit={submit} className="space-y-4">
                  <label className="block">
                    <span className="block text-sm font-medium text-[#1A1C1A] mb-1.5">Email</span>
                    <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="lupa-email-input"
                      className="w-full px-3.5 py-2.5 rounded-lg border border-[#E5E0D8] bg-white outline-none focus:border-[#E25E3E]" placeholder="email@contoh.com" />
                  </label>
                  <button type="submit" disabled={loading} data-testid="lupa-submit-btn"
                    className="w-full py-3.5 rounded-full bg-[#E25E3E] text-white font-medium hover:bg-[#C94F31] transition-colors disabled:opacity-60">
                    {loading ? "Mengirim…" : "Kirim Tautan Reset"}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
